module.exports = __webpack_public_path__ + "static/img/custom_made.bab2833.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/custom_made.png
// module id = ifPc
// module chunks = 0